import { render, staticRenderFns } from "./SubSummaryPurchaseInvoiceHeaders.vue?vue&type=template&id=0ff0d258&scoped=true&"
import script from "./SubSummaryPurchaseInvoiceHeaders.vue?vue&type=script&lang=js&"
export * from "./SubSummaryPurchaseInvoiceHeaders.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ff0d258",
  null
  
)

export default component.exports